import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './AlsoBuyingConfirmationModal.scss';

export default class AlsoBuyingConfirmationModal extends Component {
    static get propTypes() {
        return {
            requestId: PropTypes.number,
            userId: PropTypes.number,
            phone: PropTypes.string,
            isAlsoBuying: PropTypes.boolean,
            wonAgent: PropTypes.object,
            renderAction: PropTypes.string
        };
    }

    state = {
        isLoading: false,
        isUpdatingPhone: false,
        phone: this.props.phone || '',
        contentToRender: 'renderConfirmation',
        isMobile: false
    };
    phoneInputRef = React.createRef();

    get confirmButtonText() {
        return `${this.state.isMobile ? 'Use' : 'Yes, use'} ${this.props.wonAgent.firstName} as my buyer agent`;
    }

    componentWillMount() {
        const {wonAgent, renderAction, isAlsoBuying} = this.props;
        if ((!wonAgent.firstName || !renderAction) && isAlsoBuying) {
            this.setState({contentToRender: 'renderDisapproval'});
        }

        if (!wonAgent || renderAction === 'decline') {
            this.setState({contentToRender: 'renderDisapproval'});
        }

        if (renderAction == 'accept') {
            this.handleConfirmation();
        }
    }

    componentDidMount() {
        this.mql = window.matchMedia('(min-width: 768px)');
        this.setState({isMobile: !this.mql.matches});
        this.mql.addListener(this.handleMediaQuery);
    }

    componentWillUnmount() {
        this.mql.removeListener(this.isMobile);
    }

    handleMediaQuery = ({matches}) => {
        this.setState({isMobile: !matches});
    };

    handlePhoneInput(event) {
        const phone = returnNumbersOnly(returnPhoneFormat(event.target.value));
        this.setState({phone});
    }

    handlePhoneChangeFormSubmit(event) {
        event.preventDefault();

        const $phoneInput = $(this.phoneInputRef.current);
        if (!$phoneInput.valid()) {
            return;
        }

        $.post('update-user-json', {
            userId: this.props.userId,
            phone: this.state.phone
        }).then(data => {
            checkAjax(data);
        }).fail(() => {
            defaultAjaxError();
        });

        this.setState({isUpdatingPhone: false});
    }

    handleConfirmation = () => {
        const {requestId} = this.props;

        this.setState({isLoading: true});
        trackEvent('Flow', 'AlsoBuying', 'sellerClickAlsoBuyingSectionYes');

        $.post(`createAlsoBuyingRequestBySeller-json?requestId=${requestId}`)
            .then(() => {
                this.setState({contentToRender: 'renderAcceptance'});
            })
            .always(() => this.setState({isLoading: false}));
    };

    renderDisapproval = () => {
        const {wonAgent} = this.props;
        const {isUpdatingPhone, isLoading, phone} = this.state;

        return (
            <form className="modal nu-modal mod also-buying-confirmation-modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">
                                <div className="mt-2x-sm mb-4x text-center">
                                    <img src={global.imageBaseUrl + 'proposal/cart_squircle_blue.svg'}/>
                                </div>
                                Thanks for letting us know!
                            </div>
                        </div>
                        <div className="modal-body">
                            {isUpdatingPhone ? (
                                <form
                                    className="mt-3x mb-5x mb-7x-sm phone-change-form"
                                    onSubmit={this.handlePhoneChangeFormSubmit.bind(this)}>
                                    <div className="inputs">
                                        <input
                                            ref={this.phoneInputRef}
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            className="form-control phoneUS"
                                            value={returnPhoneFormat(phone)}
                                            onInput={this.handlePhoneInput.bind(this)}
                                        />
                                        <input
                                            type="submit"
                                            className="btn btn-blue"
                                            value="Change"
                                            disabled={!phone || phone.length < 10}
                                        />
                                    </div>
                                    <label htmlFor="phone" className="error" generated="true" style="display: none"/>
                                </form>
                            ) : (
                                <div className="message">
                                    Your UpNest advisor will call you at
                                    <br/>
                                    <span className="text-bold">{returnPhoneFormat(phone)}</span>{' '}
                                    {wonAgent
                                        ? 'shortly to make sure we can find the right agent for you'
                                        : 'shortly to discuss your needs.'}
                                    <div className="mt-2x mb-3x mb-5x-sm">
                                        <a
                                            className="phone-change"
                                            onClick={() => this.setState({isUpdatingPhone: true})}>
                                            Call me at another number
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-gray-outline" data-dismiss="modal">
                                Close
                            </button>
                        </div>
                        {isLoading && (
                            <div className="loadingSpinner" style="display: block; margin: 0">
                                <img src={global.imageBaseUrl + 'spinner.gif'}/>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        );
    };

    renderAcceptance = () => {
        const {
            wonAgent: {filteredPhoto, firstName}
        } = this.props;
        const {isUpdatingPhone, isLoading, phone} = this.state;
        return (
            <form className="modal nu-modal mod also-buying-confirmation-modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">
                                <div className="mt-2x-sm mb-4x text-center">
                                    <img className="agent-photo" src={global.imageBaseUrl + 'proposal/cart_squircle_blue.svg'}/>
                                    <div className="icon-container">
                                        <i className="icon-also-buying"></i>
                                    </div>
                                </div>
                                Awesome!
                                <br/> We’ll let {firstName} know.
                            </div>
                        </div>
                        <div className="modal-body">
                            {isUpdatingPhone ? (
                                <form
                                    className="mt-3x mb-5x mb-7x-sm phone-change-form"
                                    onSubmit={this.handlePhoneChangeFormSubmit.bind(this)}>
                                    <div className="inputs">
                                        <input
                                            ref={this.phoneInputRef}
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            className="form-control phoneUS"
                                            value={returnPhoneFormat(phone)}
                                            onInput={this.handlePhoneInput.bind(this)}
                                        />
                                        <input
                                            type="submit"
                                            className="btn btn-blue"
                                            value="Change"
                                            disabled={!phone || phone.length < 10}
                                        />
                                    </div>
                                    <label htmlFor="phone" className="error" generated="true" style="display: none"/>
                                </form>
                            ) : (
                                <div className="message">
                                    Your UpNest advisor will call you at
                                    <br/>
                                    <span className="text-bold">{returnPhoneFormat(phone)}</span> shortly to discuss
                                    your needs.
                                    <div className="mt-2x mb-3x mb-5x-sm">
                                        <a
                                            className="phone-change"
                                            onClick={() => this.setState({isUpdatingPhone: true})}>
                                            Call me at another number
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-gray-outline" data-dismiss="modal">
                                Close
                            </button>
                        </div>
                        {isLoading && (
                            <div className="loadingSpinner" style="display: block; margin: 0">
                                <img src={global.imageBaseUrl + 'spinner.gif'}/>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        );
    };

    renderConfirmation() {
        const {wonAgent: {filteredPhoto, firstName}} = this.props;
        const {isLoading} = this.state;
        return (
            <form className="modal nu-modal mod also-buying-confirmation-modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">
                                <div className="mt-2x-sm mb-4x text-center">
                                    <img className="agent-photo" src={filteredPhoto}/>
                                    <div className="icon-container">
                                        <i className="icon-also-buying"></i>
                                    </div>
                                </div>
                                Would you also like to use
                                <br/> {firstName} to help with your <br/>
                                home purchase?
                            </div>
                            <div className="close-btn" data-dismiss="modal">
                                <i className="icon-nav-close"></i>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="message">
                                <div className="realtor-label">RECOMMENDED</div>
                                Our top listing agents represent many sellers, they may have the dream home you are
                                looking for.
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="btn orange rounded btn-confirm" onClick={this.handleConfirmation}>
                                {this.confirmButtonText}
                            </div>
                            <div
                                className="btn-decline-realtor"
                                onClick={() => {
                                    trackEvent('Flow', 'AlsoBuying', 'sellerClickAlsoBuyingSectionNo');
                                    this.setState({contentToRender: 'renderDisapproval'});
                                }}>
                                I need another buyer agent
                            </div>
                        </div>
                        {isLoading && (
                            <div className="loadingSpinner" style="display: block; margin: 0">
                                <img src={global.imageBaseUrl + 'spinner.gif'}/>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        );
    }

    render() {
        return this[this.state.contentToRender]();
    }
}
